import './AppNotification.scss';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { NOTIFICATION_TYPE } from '../../../constants/common';

interface Props {
  message: string;
  type: string;
}

const AppNotification = ({message, type}: Props) => {

  const getNotificationClassName = () => {
    const baseClassName = 'c-app-notification';
    let newClassName = baseClassName; 
    switch(type) {
      case NOTIFICATION_TYPE.error:
        newClassName = `${baseClassName} ${baseClassName}--error`;
        break;
      case NOTIFICATION_TYPE.neutral:
        newClassName = `${baseClassName} ${baseClassName}--neutral`;
        break;
      case NOTIFICATION_TYPE.success:
        newClassName = `${baseClassName} ${baseClassName}--success`;
        break;
      case NOTIFICATION_TYPE.warning:
        newClassName = `${baseClassName} ${baseClassName}--warning`;
        break;
    }
    return newClassName;
  }

  return (
    <div className={getNotificationClassName()}>
      {type === NOTIFICATION_TYPE.success && <CheckCircleOutlineIcon className="icon-notification icon-notification--success" />}
      {type === NOTIFICATION_TYPE.warning && <ErrorOutlineIcon className="icon-notification icon-notification--warning" />}
      {type === NOTIFICATION_TYPE.neutral && <InfoOutlinedIcon className="icon-notification icon-notification--neutral" />}
      {type === NOTIFICATION_TYPE.error && <WarningAmberIcon className="icon-notification icon-notification--error" />}
      <p dangerouslySetInnerHTML={{ __html: message }}></p>
    </div>
  );
};

export default AppNotification;
